<template>
  <div>
    <div v-if="value" class="items-center">
      <div class="flex justify-center text-dark font-bold">
        <feather-icon icon="CalendarIcon" svgClasses="h-3 w-3" class="mr-1" />
        <p class="text-xl">deadline</p>
      </div>


      <div v-if="!pickerVisible" class="flex justify-center text-dark items-center" :class="actionElementCss" @click="pickerVisible = true">

        <Deadline class="ml-2" :value="value" :hideIcon="true" :redOverdue="true" />

        <feather-icon  icon="EditIcon" class="ml-1 w-4 cursor-pointer"  />

        <!-- <feather-icon v-if="localValue" icon="XSquareIcon" :class="actionElementCss" class="w-4 ml-1" @click="localValue= '' " /> -->

      </div>

    </div>

    <div v-else >
      <div v-if="!pickerVisible" class="flex justify-center text-dark font-bold" :class="actionElementCss" @click="pickerVisible = true">
        <feather-icon icon="CalendarIcon" svgClasses="h-3 w-3" class="mr-1" />
        <p class="text-xl" >deadline +</p>
      </div>

      <div v-else class="flex justify-center text-dark font-bold">
        <feather-icon icon="CalendarIcon" svgClasses="h-3 w-3" class="mr-1" />
        <p class="text-xl">deadline</p>
      </div>
    </div>

    <div class="flex justify-center">
      <div v-if="pickerVisible">

        <div class="mt-2 flex justify-center" v-if="taskMetadates">
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="today" vs-name="deadline-picker-today">today</vs-radio>
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="tomorrow" vs-name="deadline-picker-tomorrow">tomorrow</vs-radio>
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="soon" vs-name="schedule-afternoon">soon</vs-radio>

        </div>

        <div class="mt-2 flex justify-center" v-if="taskMetadates">
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="someday" vs-name="schedule-nighttime">someday</vs-radio>
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="specific_day" vs-name="schedule-nighttime">specific day</vs-radio>
        </div>


        <div class="mt-2 flex justify-center" v-if="goalMetadates">
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="end_of_this_month" vs-name="deadline-picker-today">this month</vs-radio>
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="end_of_next_month" vs-name="deadline-picker-tomorrow">next month</vs-radio>

        </div>

        <div class="mt-2 flex justify-center" v-if="goalMetadates">
          <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="someday" vs-name="schedule-nighttime">someday</vs-radio>
         <vs-radio color="dark" class="mx-2" v-model="localMetaValue" vs-value="specific_day" vs-name="schedule-nighttime">specific day</vs-radio>
        </div>

        <div class="mt-2" v-if="specificDay">
          <flat-pickr :config="configInlineDateTimePicker" v-model="localValueResult" placeholder=""/>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { midnight, midnightTomorrow, formatyyymmdd, isMetadate, endOfMonth, endOfNextMonth, parseInCurrentTimezone } from '@/helpers/date'

const CALENDAR_CONFIG = {
  disableMobile: false,
  parseDate: (datestr) => parseInCurrentTimezone(datestr),
  inline: true,
  altInput: true, // optional
  altInputClass: 'hide-me',  // optional
  // wrap: true,
  locale: { firstDayOfWeek: 1 }
}

import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr
  },
  // value - date or soon/someday
  props: ['value', 'goalMetadates', 'taskMetadates', 'showPickerInitially'],
  data () {
    return {
      pickerVisible: false,
      localMetaValue: null,
      localValueResult: null,
      configInlineDateTimePicker: CALENDAR_CONFIG,
    }
  },
  computed: {
    specificDay () {
      return this.localMetaValue === 'specific_day'
    },
    today () {
      return formatyyymmdd(midnight())
    },
    tomorrow () {
      return formatyyymmdd(midnightTomorrow())
    },
    endOfMonth () {
      return formatyyymmdd(endOfMonth())
    },
    endOfNextMonth () {
      return formatyyymmdd(endOfNextMonth())
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.pickerVisible = !!this.showPickerInitially

        console.log('----------------')
        console.log('deadline picker: value', value)
        console.log('deadline picker: isMetadate(value)', isMetadate(value))
        console.log('end of setup deadline picker: localMetaValue', this.localMetaValue)

        if (isMetadate(value)) {
          // this.localValueResult = null
          this.localMetaValue = value || 'someday'
        } else {
          this.localValueResult = value
          this.localMetaValue = 'specific_day'
        }

        if (this.value === this.today) {
          this.localMetaValue = 'today'
        } else if (this.value === this.tomorrow) {
          this.localMetaValue = 'tomorrow'
        } else if (this.value === this.endOfMonth) {
          this.localMetaValue = 'end_of_this_month'
        } else if (this.value === this.endOfNextMonth) {
          this.localMetaValue = 'end_of_next_month'
        }


        console.log('end of setup deadline picker: value', value)
        console.log('end of setup deadline picker: localMetaValue', this.localMetaValue)
        console.log('end of setup deadline picker: isMetadate(value)', isMetadate(value))
      }
    },
    localValueResult: {
      immediate: false,
      handler (localValueResult) {
        this.$emit('input', localValueResult)
      }
    },
    localMetaValue: {
      immediate: false,
      handler (localMetaValue) {
        console.log('localMetaValue change', localMetaValue)

        if (localMetaValue === 'specific_day') {
          // this.localValueResult = localMetaValue
          // parseInCurrentTimezon`xwzxe``
          return
        }

        if (localMetaValue === 'today') {
          this.localValueResult = this.today
        } else if (localMetaValue === 'tomorrow') {
          this.localValueResult = this.tomorrow
        } else if (localMetaValue === 'end_of_this_month') {
          this.localValueResult = this.endOfMonth
        } else if (localMetaValue === 'end_of_next_month') {
          this.localValueResult = this.endOfNextMonth
        } else {
          this.localValueResult = localMetaValue
        }

      }
    }
  },
}
</script>
